import NewTemplate from './NewTemplate';
import NewTemplateController from './NewTemplateController';

export { NewTemplate };

export default NewTemplateController;
